function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(2.6667 0 0 2.6667 -.0004504 -5.1498e-7)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "m20 0h-16a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h2.9l4.451 3.763a1 1 0 0 0 1.292 0l4.457-3.763h2.9a4 4 0 0 0 4-4v-12a4 4 0 0 0-4-4zm2 16a2 2 0 0 1-2 2h-2.9a2 2 0 0 0-1.291 0.473l-3.809 3.217-3.807-3.217a2 2 0 0 0-1.293-0.473h-2.9a2 2 0 0 1-2-2v-12a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m7 7h5a1 1 0 0 0 0-2h-5a1 1 0 0 0 0 2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m17 9h-10a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m17 13h-10a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2z"
}));
function SvgCommentAlt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentAlt);
export default __webpack_public_path__ + "static/media/comment-alt.9b7e3285.svg";
export { ForwardRef as ReactComponent };